module.exports = __webpack_public_path__ + "static/media/download-icon.4ead4c55.svg";